import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

export default class extends Controller {
  connect() {
    this.tippy = tippy(this.element, {
      content: this.element.dataset.tippyContent,
      maxWidth: 300
    })
  }

  disconnect() {
    if (this.tippy) {
      this.tippy.destroy()
    }
  }
}
